import styled from 'styled-components';

const EndColumnsContainer = styled.div`
  display: flex;
  margin-left: auto;
  justify-content: end;
`;
export default EndColumnsContainer;
